import { render, staticRenderFns } from "./commissionList.vue?vue&type=template&id=21da81b4&scoped=true"
import script from "./commissionList.vue?vue&type=script&lang=js"
export * from "./commissionList.vue?vue&type=script&lang=js"
import style0 from "./commissionList.vue?vue&type=style&index=0&id=21da81b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da81b4",
  null
  
)

export default component.exports